/* eslint-disable react-hooks/exhaustive-deps */
import Lottie from 'lottie-react';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import {
  matchPath,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
// import { AESDecrypt, AESEncrypt } from '../../../encrypt-util';
import { AESDecrypt, AESEncrypt } from '../../../encrypt-util';
import infiniteLoop from '../../../assets/img/animated-icons/infinite-loop.json';
import { AppDispatch, RootState } from '../template/store';
import DataTable from '../../common/components/DataTable';
import { IDataTableColumn } from '../../common/types/dataTable';
import {
  toggleDHColumnSettings,
  updateSelectedEventIdDH,
  updateSelectedDocIdDH,
  updateSelectedRoute,
  updateInstructionID,
} from '../blDetails/slices/documentHistorySlice';
import { getEBLHistory } from './actions/eBLActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv, faRefresh } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';



const EDocumentHistory = () => {
  const { blId } = useParams()
  const blNumber = useSelector((state: RootState) => state.oblDetails.oblForm.number);

  const dispatch = useDispatch<AppDispatch>();
  // const data = useSelector((state: RootState) => state.documentHistory.data);

  const eblHistory = () => {
    dispatch(getEBLHistory({ eBLNo: blNumber }))
  }

  useEffect(() => {
    if(blNumber){
      eblHistory()
    }

  },[blNumber])

  const eBLDocumentHistory: any = useSelector(
    (state: RootState) => state.eBLDocumentHistory.eBLDocumentHistory
  );

  const data = eBLDocumentHistory?.map((history: any) => ({
    action: history?.action,
    actor_company: history?.actorCompany,
    actor_user: history?.actorUser,
    action_time: history?.createdOn,
    status: history?.status,
    actor_email: history?.actorEmail

  })) || [];


  const columns: IDataTableColumn[] = [
    {
      accessor: 'action',
      Header: 'Action',
      width: 100,
      maxWidth: 250
    },
    {
      accessor: 'actor_company',
      Header: 'Actor Company',
      width: 150,
      maxWidth: 250

    },
    {
      accessor: 'actor_user',
      Header: 'Actor User',
      width: 250,
      maxWidth: 350
    },
    {
      accessor: 'action_time',
      Header: 'Action Time',
      width: 200,
      maxWidth: 350,
      Cell: (rowData: any) => {
        const { action_time } = rowData.row.original;
        return new Date(action_time).toLocaleString();
      },
    },
    {
      accessor: 'status',
      Header: 'Status',
      width: 100,
      maxWidth: 250
    },
    {
      accessor: 'actor_email',
      Header: 'Actor Email',
      width: 200,
      maxWidth: 350
    }
  ];

  const isEDocumentHistoryLoading = useSelector(
    (state: RootState) => state.eBLDocumentHistory.dataLoading
  );

  const showDHColumnSettings = useSelector(
    (state: RootState) =>
      state.documentHistory.showDocumentHistoryColumnSettings
  );

  const _onHideDHColumnSettings = () => {
    dispatch(toggleDHColumnSettings(false));
  };

  return isEDocumentHistoryLoading ? (
    <div className='w-100 h-100 d-flex justify-content-center align-items-center'>
      <Lottie
        animationData={infiniteLoop}
        loop={true}
        style={{ height: '80px', width: '80px' }}
      />
    </div>
  ) : (
      <>
        <div className="d-flex justify-content-start px-3 pt-2 overflow-auto me-2">
          <Button
            className='me-2 mb-2'
            variant='falcon-primary'
            size='sm'
            onClick={() => {
              eblHistory()
            }
            }
          >
            <FontAwesomeIcon icon={faRefresh} style={{ fontSize: '14px', color: '#f5822a' }} className='me-2' />
          </Button>
  </div>
        <div className='w-100 h-100 overflow-auto border-right d-flex flex-column p-3'>
          <DataTable
            data={data}
            columns={columns}
            sortable={true}
            selection={false}
            searchable={false}
            pagination={true}
            tableMinHeight={400}
            perPage={1000}
            gridName='E_DOCUMENT_HISTORY'
            showColumnFilter={true}
            showExport={false}
            showColumnSettings={showDHColumnSettings}
            onHide={_onHideDHColumnSettings}
            columnSettingsPersistKey='@odex/document-history/v1'
            showPagination={false}
            defaultHiddenCols={['blEventId', 'blId', 'docId']}
            staticHiddenCols={['blEventId', 'blId', 'docId']}
            localFilter={true}
            uniqueFilterKey='filterKey'
            addTbodyBreak
          />
        </div>
      </>)

};

export default EDocumentHistory;

